import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Signup from './pages/Signup';
import Form from './pages/Form';
import V2 from './pages/V2';
import CrmBonus from './pages/CrmBonus';
import Allya from './pages/Allya';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<V2 />} />
        <Route path="/cadastro" element={<Signup />} />
        <Route path="/form" element={<Form />} />
        <Route path="/crmbonus" element={<CrmBonus />} />
        <Route path="/allya" element={<Allya />} />
        <Route path="/index_old" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;